export default "/assets/20297e467fb081cb.svg"